<template>
    <c-dialog
        ref="dialog"
        title="选择客户地址"
        width="900"
        height="480"
        @resolve="confirmSelection"
    >
        <page>
            <module enable-flex>
                <m-search ref="search" @search="searchHandle">
                    <m-search-item label="地址详情">
                        <c-input name="address_detail"></c-input>
                    </m-search-item>
                </m-search>
                <c-table ref="addressList" height="grow" :paging="{ size: 10 }">
                    <c-table-column
                        type="selector"
                        width="32"
                        @handle="batchSelect"
                    ></c-table-column>
                    <c-table-column label="客户地址" width="200">
                        <template #default="{ data }">
                            <span>{{ fullRegion(data) }}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="经度" name="longitude" width="110"></c-table-column>
                    <c-table-column label="纬度" name="latitude" width="110"></c-table-column>
                    <c-table-column label="备注" name="remark" width="120"></c-table-column>
                </c-table>
            </module>
        </page>
    </c-dialog>
</template>

<script>
import { batchData, batchMethods } from '@/components/public/batch.js';

export default {
    data() {
        return {
            customerId: null,
            ...batchData()
        };
    },
    methods: {
        ...batchMethods('addressList'),
        fullRegion(data) {
            if (!data) return '';
            return [data.province_name, data.city_name, data.county_name,data.address_detail].filter(Boolean).join('');
        },
        searchHandle(data) {
            if (!this.customerId) {
                return;
            }
            if (!data) {
                data = { pageIndex: 1, pageSize: 10 };
            }
            data.customer_id = this.customerId;
            this.$refs.addressList.load({
                url: '/customer/address/list',
                data
            });
        },
        open(customerId) {
            this.customerId = customerId;
            this.$refs.dialog.open();
            this.$nextTick(() => {
                this.searchHandle({ pageIndex: 1, pageSize: 10 });
            });
        },
        confirmSelection(stop, next) {
            const selected = this.$refs.addressList.getData('selected');
            if (!selected || selected.length === 0) {
                this.$message({
                    message: '请选择一条客户地址',
                    type: 'warning'
                });
                return;
            }
            if (selected.length > 1) {
                this.$message({
                    message: '只能选择一条客户地址',
                    type: 'warning'
                });
                return;
            }
            const row = selected[0];
            if (row.longitude == null || row.latitude == null) {
                this.$message({
                    message: '该地址缺少经纬度，请先在客户地址中补全定位',
                    type: 'warning'
                });
                return;
            }
            stop();
            this.$emit('confirm', row);
            next();
        }
    }
};
</script>
